import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import LLMMarkdownSection from 'llm/markdown/LLMMarkdownSection';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_LIGHTER, GRAY_LIGHT, GRAY_DARKER} from 'ui-library/Colors';

export enum DeepResearchMessageType {
  USER_MESSAGE = 'USER_MESSAGE',
  SYSTEM_REPORT = 'SYSTEM_REPORT',
}

export interface DeepResearchMessage {
  type: DeepResearchMessageType;
  content: string;
  timestamp: Date;
}

export interface DeepResearchMessageComponentProps {
  message: DeepResearchMessage;
}

function UserMessage({message}: {message: DeepResearchMessage}): JSX.Element {
  return (
    <div className={css(styles.userMessageWrapper)} data-testid="user-message">
      <div className={css(styles.userMessageContent)}>{message.content}</div>
    </div>
  );
}

function SystemReportMessage({message}: {message: DeepResearchMessage}): JSX.Element {
  return (
    <div className={css(styles.systemReportWrapper)} data-testid="system-report-message">
      <div className={css(styles.systemReportContainer)}>
        <div className={css(styles.systemReportContent)}>
          <LLMMarkdownSection markdown={message.content} />
        </div>
        {/* TODO (BNCH-124960): Add save button */}
        {/* <div className={css(styles.systemReportToolbar)}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.MINI}
            onClick={noop}
            icon={<BenchlingIcon icon="save" />}
          />
        </div> */}
      </div>
      <div className={css(styles.systemReportFooter)} data-testid="system-report-footer">
        Reports are not auto saved during beta
      </div>
    </div>
  );
}

export function DeepResearchMessageComponent({message}: DeepResearchMessageComponentProps): JSX.Element {
  return (
    <div className={css(styles.messageContainer)}>
      {message.type === DeepResearchMessageType.USER_MESSAGE ? (
        <UserMessage message={message} />
      ) : (
        <SystemReportMessage message={message} />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  // Message container for layout and spacing
  messageContainer: {
    paddingBottom: '12px',
    paddingTop: '12px',
  },

  // User message styles
  userMessageWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  userMessageContent: {
    maxWidth: '80%',
    padding: '12px 16px',
    backgroundColor: GRAY_LIGHTER,
    borderRadius: '12px',
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },

  // System report styles
  systemReportWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  systemReportContainer: {
    border: `1px solid ${GRAY_LIGHT}`,
    borderRadius: '12px',
    padding: '16px 16px 8px 16px',
  },
  systemReportContent: {
    ...FONT_PROXIMA_14,
  },
  systemReportToolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  systemReportFooter: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: GRAY_DARKER,
    fontSize: '12px',
    padding: '4px 12px',
    textAlign: 'center',
  },
});

export default DeepResearchMessageComponent;
